import { getComsMobx } from '../util/convert';
const { WeaForm } = getComsMobx();

import { observable, action } from 'mobx';
import { getRemindData,doRemind } from '../apis/req';

export class RemindSetStore {

    @observable form = new WeaForm();
    @observable condition = [];
    @observable isSubmiting = false;
    /**
     * 初始数据
     */
    @action getRemindData(para={}){
        getRemindData(para).then((reVal)=>{
            this.condition = reVal.condition;
            this.form.initFormFields(reVal.condition);
        });
    }

    /**
     * 提醒
     */
    @action doRemind(para={}){
        if (!this.isSubmiting) {
            this.isSubmiting = true;
            doRemind(para).then((reVal)=>{
                this.isSubmiting = false;
            });
        }

    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/workflowForm/stores/remindSet.js